import { gql } from '@apollo/client';
import type { Report2PerceptionSectionFragment } from '../../../../../generated/types';
import { useReportDynamicData } from '../../../hooks';
import {
  SectionDescription,
  SectionGroup,
  SectionHeader,
  SectionHeaderGrid,
  SectionInsights,
} from '../../common';
import PerceptionSentimentOverTime from './PerceptionSentimentOverTime';
import PerceptionSentimentOverview from './PerceptionSentimentOverview';

export const REPORT2_PERCEPTION_SECTION_FRAGMENT = gql`
  fragment Report2PerceptionSection on ReportPerceptionSection {
    id
    title
    state
    subSections {
      ...Report2PerceptionSentimentOverview
      ...Report2SectionInsights
      ...Report2PerceptionSentimentOverTime
    }
  }
`;

export const PerceptionSection = ({ section }: { section: Report2PerceptionSectionFragment }) => {
  const { brandColor } = useReportDynamicData();

  return (
    <SectionGroup id={section.id}>
      <SectionHeaderGrid>
        <SectionHeader
          as="h2"
          variant="reportDisplayLarge"
          mobileVariant="reportDisplaySmall"
          section={section}
          color={brandColor}
        />
        <SectionDescription
          as="p"
          variant="reportLabelMedium"
          textAlign="right"
          section={section}
        />
      </SectionHeaderGrid>

      {section.subSections.map(subSection => {
        switch (subSection.__typename) {
          case 'ReportPerceptionSentimentOverview':
            return <PerceptionSentimentOverview key={subSection.id} section={subSection} />;
          case 'ReportSectionInsights':
            return <SectionInsights key={subSection.id} section={subSection} />;
          case 'ReportPerceptionSentimentOverTime':
            return <PerceptionSentimentOverTime key={subSection.id} section={subSection} />;
          default:
            return null;
        }
      })}
    </SectionGroup>
  );
};
